import React from "react";
import PhysicalBanner from "../physicalrecords/PhysicalBanner";
import DigiHub from "./DigiHub";
import PhysicalDocs from "../physicalrecords/PhysicalDocs";
import DigiRapid from "./DigiRapid";
import PhysicalClientLogo from "../physicalrecords/PhysicalClientLogo";
import PhysicalGrowth from "../physicalrecords/PhysicalGrowth";
import PhysicalStorage from "../physicalrecords/PhysicalStorage";
import PhysicalTool from "../physicalrecords/PhysicalTool";
import PhysicalAdopt from "../physicalrecords/PhysicalAdopt";
import PhysicalFaq from "../physicalrecords/PhysicalFaq";
export default function DigitizationServices() {

  const physicalData = {
    img: "/assets/images/digi-service-banner-img.webp",
    head: "Seamlessly Transform Paper Records into Digital Intelligence",
    btn: "Contact Us",
    slug:"/contact"
  };

  const hubData = {
    head: "From Paper to Digital, Done Right",
    desc: `<Dox and Box>Digitization is more than scanning. It is about creating reliable, accessible, future-ready information. Dox and Box helps organizations seamlessly transition from paper-based systems to fully digitized environments with accuracy, security, and efficiency at every stage.
</p>`,
    boxes: [
      {
        img: "/assets/images/digi-hub-img-1.webp",
        label: "Bulk Document Scanning"
      },
      {
        img: "/assets/images/digi-hub-img-2.webp",
        label: "On-Demand Document Scanning"
      },
      {
        img: "/assets/images/digi-hub-img-3.webp",
        label: "Large Format Scanning"
      },
      {
        img: "/assets/images/digi-hub-img-4.webp",
        label: "Book Scanning"
      },
      {
        img: "/assets/images/digi-hub-img-5.webp",
        label: "Document Indexing and Metadata Services"
      },
      {
        img: "/assets/images/digi-hub-img-6.webp",
        label: "OCR and Data Capture Services"
      },

    ]
  }

  const accordData = {
    head: "How the Document Scanning Process Works",
    desc: "A structured, secure, end-to-end workflow designed for accuracy and control.",
    boxes: [
      {
        head: "Order Initiation",
        para: 'We understand your requirements, document types, volume, timelines to create a tailored digitization plan.',
        img: "/assets/images/digi-hub--docs-img-1.webp",

      },
      {
        head: "Document Inspection and Preparation",
        para: 'Documents are reviewed, sorted, cleaned, prepared for scanning to ensure optimal image quality and accuracy.',
        img: "/assets/images/digi-hub--docs-img-2.webp",
      },
      {
        head: "Secure Document Transportation",
        para: 'Records are securely transported to our digitization facility with full tracking and handling protocols in place.',
        img: "/assets/images/digi-hub--docs-img-3.webp",
      },
      {
        head: "High-Precision Scanning",
        para: 'Documents are scanned using advanced equipment to capture clear, high-resolution digital images.',
        img: "/assets/images/digi-hub--docs-img-4.webp",
      },
      {
        head: "Quality Check and Validation",
        para: 'Each scanned file undergoes rigorous quality checks to ensure completeness, clarity, accuracy.',
        img: "/assets/images/digi-hub--docs-img-5.webp",
      },

      {
        head: "Digital Upload and Delivery",
        para: 'Final files are securely uploaded to the cloud or delivered in your preferred format, ready for easy access and integration.',
        img: "/assets/images/digi-hub--docs-img-6.webp",
      },
    ]
  }

  const growthData = {
    head: "95% of customers report improved efficiency and business growth through our digitization services",
    btn: "Book A Consultation",
    newClass: "",
    slug: '',
  }

  const storageData = {
    head: "Benefits of Digitization Services",
    desc: `<p><b>Large Format Scanning,</b> Services improve document accessibility, reduce storage space, enhance <b> Workflow Efficiency </b> by converting oversized drawings into formats.</p>`,
    boxes: [
      {
        img: "/assets/images/digi-large-icon-1.webp",
        label: "Reduce physical storage costs"
      },

      {
        img: "/assets/images/digi-large-icon-2.webp",
        label: "Enable instant access to documents"
      },

      {
        img: "/assets/images/digi-large-icon-3.webp",
        label: "Improve compliance and record retention"
      },

      {
        img: "/assets/images/digi-large-icon-4.webp",
        label: "Enhance collaboration across teams"
      },

      {
        img: "/assets/images/digi-large-icon-5.webp",
        label: "Scale document management with ease"
      },

      {
        img: "/assets/images/digi-large-icon-6.webp",
        label: "Save valuable office space"
      },
    ]

  }

  const countData = {
    title: "Faster Access, Less Paperwork",
    para: "Transform physical records into secure, searchable digital files that are easy to manage and retrieve.",
    btn: "Digitize Your Documents Today",
    stats: [
      {
        number: "99",
        suffix: "%",
        desc: "faster document retrieval"
      },
      {
        number: "84",
        suffix: "%",
        desc: "reduction in storage space"
      },
      {
        number: "95",
        suffix: "%",
        desc: "increase in productivity"
      },
    ]
  }

  const adoptData = {
    firstimg: "assets/images/physical-adopt-blur.webp",
    secondimg: "/assets/images/physical-adopt-img1.webp",
    thirdimg: "/assets/images/physical-adopt-img2.webp",
    name: "Ritesh Verma",
    position: "General Manager",
    desc: "Dox and Box streamlined our document workflows and eliminated manual bottlenecks. The system is secure, reliable, easy for teams to adopt. We’ve seen faster turnaround times and better compliance tracking, improving operational efficiency while reducing costs."
  }

  const faqData = {
  image:"/assets/images/physical-faq-img.webp",
  faqs:[
    {
      question:"What types of documents can be digitized?",
      answer:"We can digitize a wide range of materials including paper files, books, invoices, contracts, HR records, engineering drawings, blueprints, even microfilm. Our process supports both standard and large-format documents."
    },
    {
      question:" How secure is the document digitization process?",
      answer:"Security is maintained at every stage. Documents are handled under strict protocols, securely transported, processed in controlled environments. Access is restricted and all files are protected during and after digitization."
    },
    {
      question:"What file formats will I receive after digitization?",
      answer:"You can receive your digitized documents in formats such as PDF, TIFF, or other preferred formats. We also enable searchable files using OCR and ICR for easy retrieval."
    },
    {
      question:"How long does the digitization process take?",
      answer:"Timelines depend on document volume, type, complexity. After assessing your requirements, we provide a clear turnaround estimate and ensure timely delivery without compromising quality."
    },
    {
      question:" Can digitized documents be integrated with our existing systems?",
      answer:"Yes. Digitized files can be easily integrated with your existing document management systems, ERP, or cloud platforms, enabling seamless access and workflow automation."
    },
  ]
}

  return (
    <>
      <PhysicalBanner data={physicalData} />
      <DigiHub data={hubData} />
      <div className="ai-rapid-docs">
        <PhysicalDocs data={accordData} />
      </div>
      <DigiRapid />
      <PhysicalClientLogo />
      <PhysicalGrowth data={growthData} />
      <PhysicalStorage data={storageData} />
      <div className="digi-tool">
        <PhysicalTool countData={countData} />
      </div>
      <PhysicalAdopt data={adoptData} />
      <PhysicalFaq data={faqData}/>
    </>
  )
}